// entrypoint actions
export const GET_COMMUNICATION_DATA = 'GET_COMMUNICATION_DATA';
export const CLEAR_COMMUNICATION_DATA_STORE = 'CLEAR_COMMUNICATION_DATA_STORE';

// async actions
export const GETTING_COMMUNICATION_DATA = 'GETTING_COMMUNICATION_DATA';
export const GETTING_COMMUNICATION_DATA_SUCCEEDED =
  'GETTING_COMMUNICATION_DATA_SUCCEEDED';
export const GETTING_COMMUNICATION_DATA_FAILED =
  'GETTING_COMMUNICATION_DATA_FAILED';

export const getCommunicationData = () => ({
  type: GET_COMMUNICATION_DATA
});

export const clearCommunicationDataStore = () => ({
  type: CLEAR_COMMUNICATION_DATA_STORE
});

export const gettingCommunicationData = () => ({
  type: GETTING_COMMUNICATION_DATA
});
export const gettingCommunicationDataSucceeded = communicationData => ({
  type: GETTING_COMMUNICATION_DATA_SUCCEEDED,
  communicationData
});
export const gettingCommunicationDataFailed = error => ({
  type: GETTING_COMMUNICATION_DATA_FAILED,
  error
});
